import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import AI_LIST_PROMPT_REPORTS_QUERY from '../queries/AI_LIST_PROMPT_REPORTS_QUERY';
import { getFormattedDateTime } from '../../utils';

const useAIListPromptReports = ( promptId ) => {
    const [ reports, setReports ] = useState( [] );
    const { data, loading, error } = useQuery( AI_LIST_PROMPT_REPORTS_QUERY, 
        { 
            variables: { promptId: promptId },
            fetchPolicy: 'network-only'  
        } 
    );

    useEffect( () => {
        if ( loading || error || !data || !data.promptReports ) { return; }
        
        try {
            const result = data.promptReports.map( i => { 
                return {
                    ...i, 
                    key: i.id || '',
                    createdAt: getFormattedDateTime( i.createdAt ) 
                };
            } );
            
            setReports( result ); 
        } catch ( error ) {
            console.error( 'Error parsing reports', error ); 
            setReports( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            reports,
            reportsError: error,
            reportsLoading: loading, 
        };
    }, [ reports, error, loading ] );
};

export default useAIListPromptReports;
